<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <div class="form-check">
        <label class="form-check-label">
          <input class="form-check-input" type="checkbox" :name="safeId()" v-model="localValue">{{ text }}</label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'checkbox-input-group',
    props: ['label', 'value', 'text'],
    data () {
      return {
        localValue: this.value
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = !!val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/checkbox-input-group.vue